<template>
  <span
    class="bg-transparent item-wrapper"
    style="
      min-height: 80px;
      min-width: 80px;
      max-width: 100px;
      max-height: 100px;
    "
    :class="{
      active: isActive,
    }"
  >
    <svg
      viewBox="0 0 80 80"
      version="1.1"
      ref="svg"
      :style="getSvgBorderStyle"
      :class="[
        disabled ? 'opacity-25 cursor-not-allowed' : '',
      ]"
      class="border border-2 rounded p-0 shadow scroll-item clickable"
    >
      <image
        ref="image"
        v-if="plugPicAvailable"
        x="10"
        height="65"
        width="65"
        v-bind="{ 'xlink:href': picturePath }"
        @error="setPlugNotAvailable"
        @load="setPlugAvailable"
      />
      <text
        v-else
        x="40"
        y="30"
        text-anchor="middle"
        class="fill-dark-grey"
        font-size="7pt"
      >
        <tspan x="40" y="30">{{ $t("plug-image-not-available.line1") }}</tspan>
        <tspan x="40" y="40">{{ $t("plug-image-not-available.line2") }}</tspan>
      </text>

      <path
        d="M0 55 C40 55 50 55 80 47 L80 80 L0 80 Z"
        :style="getSvgFillStyle"
      />
      <text
        x="40"
        y="70"
        text-anchor="middle"
        fill="white"
        :font-size="
          (title === 'FC' ? 'FC Wide Key' : title).length <= 10 ? '8pt' : '7pt'
        "
      >
        {{ title === "FC" ? "FC Wide Key" : title }}
      </text>
    </svg>
  </span>
</template>

<script>
export default {
  name: "CarouselScrollSelectPlugType",
  props: {
    isActive: Boolean,
    title: String,
    color: {
      type: String,
      default: "blau",
    },
    cableColor: {
      type: String,
      default: "",
    },
    disabled: Boolean,
    plex: { type: String, default: "sx" },
    mode: String,
    plugId: String,
  },
  data() {
    return {
      plugPics: {
        lc: {
          sx: ["", "beige", "blau", "grün"],
          dx: ["", "beige", "blau", "grün"],
        },
        sc: {
          sx: ["", "beige", "blau", "grün"],
          dx: ["", "beige", "blau", "grün"],
        },
        st2: {
          sx: [""],
          dx: [""],
        },
        din: {
          sx: [""],
          dx: [""],
        },
        "fsma-905-raendel": {
          sx: ["", "metall"],
          dx: [""],
        },
        fc: {
          sx: ["", "Metall"],
          dx: [""],
        },
        e2000: {
          sx: ["", "grün", "blau", "beige"],
          dx: ["", "grün", "beige", "blau"],
        },
        st: {
          sx: [""],
          dx: [""],
        },
        "fc-narrow-key": {
          sx: [""],
          dx: [""],
        },
        "urm-ng-p2": {
          sx: ["", "beige", "blau", "erikaviolett", "grün"],
          dx: ["", "beige", "blau", "erikaviolett", "grün"],
        },
        "urm-ng-p8": {
          sx: ["", "beige", "blau", "erikaviolett"],
          dx: ["", "beige", "blau", "erikaviolett"],
        },
        mpo: {
          sx: [""],
          dx: [""],
        },
        "sn-ez-flip": {
         sx: ["", "blau", "aqua", "erikaviolett"],
          dx: ["", "blau", "aqua", "erikaviolett"],
        },
        // start mdc
        mdc: {
          sx: [""],
          dx: ["", "blau", "aqua", "erikaviolett"],
        },
        cs: {
          sx: [""],
          dx: ["", "blau", "erikaviolett", "aqua"],
        },
        // start mtp
        mtp: {
          sx: [""],
          dx: ["", "grün"],
        },
        mtp12: { sx: [""], dx: ["", "grün"], },
        mtp24: { sx: [""], dx: ["", "grün"], },
      },
      plugPicAvailable: true,
      height: 128,
    };
  },
  methods: {
    setPlugNotAvailable(error) {
      this.$rollbar.warning(
        `[CarouselScrollSelectPlugType] can not find plug image: ${error.srcElement.href.baseVal}`
      );
      // eslint-disable-next-line no-console
       console.log('[CarouselScrollSelectPlugType] Image load failed:', error.srcElement.href.baseVal);
      this.plugPicAvailable = false;
    },
    setPlugAvailable() {
      this.plugPicAvailable = true;
    },
  },
  computed: {
    getSvgBorderStyle() {
      if (!this.isActive) {
        return { borderColor: '#6c757d' };
      }
      return this.cableColor ? { borderColor: this.cableColor } : {};
    },
    getSvgFillStyle() {
      if (!this.isActive) {
        return { fill: '#6c757d' };
      }
      return this.cableColor ? { fill: this.cableColor } : { fill: '#1D8348' };
    },
    picturePath() {
      // MTP12 plugs (XA16-xxx) have male/female variants — their plex is "male"/"female",
      // so skip the artikel-ID path and fall through to the type+plex path to resolve
      // mtp12_male.png / mtp12_female.png correctly.
      const isMtp12 = this.plugId && /^XA16/i.test(this.plugId);
      if (this.plugId && this.plugId !== "" && this.isActive === true && !isMtp12) {
        return `${
          process.env.NODE_ENV === "production" ? "." : ""
        }/assets/plugs/${this.plugId.replace("-", "_")}.png`;
      }
      // else build the path via type, plex, mode and color
      else {
        let title = this.title
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/ä/g, "ae");

        let plex = this.plex
          ? this.plex.indexOf("Uniboot") === 0 ||
            this.plex.indexOf("URM") === 0 ||
            this.plex.indexOf("MDC") === 0 ||
            this.plex.indexOf("MTP") === 0 ||
            this.plex.indexOf("SN EZ-Flip") === 0
            ? "dx"
            : this.plex.toLowerCase()
          : "";

        plex = plex !== "" ? plex : "sx";
        let color = this.color
          ? this.color.toLowerCase()
          : this.mode === "mm"
          ? "beige"
          : "";

        const plugPicGroup = this.plugPics[title] && this.plugPics[title][plex];
        const picsIncludePlug =
          Array.isArray(plugPicGroup) && plugPicGroup.includes(color);
        let path = `${
          process.env.NODE_ENV === "production" ? "." : ""
        }/assets/plugs/${title}_${plex}${
          picsIncludePlug && color
            ? `_${color}`
            : ""
        }.png`;
        // console.log(path)
        // eslint-disable-next-line no-console
        // console.log('[CarouselScrollSelectPlugType] Image path:', path);
        return path;
      }
    },
  },
  watch: {
    plugId() {
      this.$nextTick(() => {
        this.plugPicAvailable = true;
      });
    },
  },
  mounted() {
    if (
      this.$runtimeEnvironment.isIE ||
      this.$runtimeEnvironment.isLegacyEdge
    ) {
      this.$refs.svg.setAttribute("width", 100);
      this.$refs.svg.setAttribute("height", 100);
    }
  },
};
</script>

